<template>
  <div class="bar-ctn" :style="style">
    <div :id="`chartbar_${id}`">      
    </div>
  </div>
</template>
<script>
import * as d3 from 'd3'
import reDrawTrigger from '@mx/reDrawTrigger'

import { derrorFactory, errorFactory, logFactory } from '@u/log'
// import { derrorFactory } from '@u/log'
const derror = derrorFactory('ChartBar', true)
const error = errorFactory('ChartBar', false)
const log = logFactory('ChartBar', true)

const _minGap = 5.6 // _evenHeightArr至少要有${_minGap}的高度

function _evenHeightArr(array = []) { // 由于百分比可能会导致有些矩形特别矮，甚至可能为0，所以需要做一个缓冲(即给一个最低高度)
  /* eslint-disable */
  const _defaultArr = [20, 20, 20, 20, 20]
  log(`_evenHeightArr, array: ${array}`)
  if (_evenHeightArr._count === undefined) {
    if (array.length == 0) {
      return _defaultArr
    }
    _evenHeightArr._count = 1
  } else {
    _evenHeightArr._count += 1
  }
  
  if (_evenHeightArr._count > 100) {
    error(`_evenHeightArr递归次数超过，避免死循环，直接return array: ${array}`)
    return array
  }
  /* eslint-enable */
  const arr = array.slice()  
  
  if (arr.every(v => {
    return !v
  })) { // 全是0
    // reset
    _evenHeightArr._count = 1
    return _defaultArr
  }
  
  const _lessThanMinIndexs = []  
  
  arr.forEach((v, i) => {
    const pass = v - _minGap < 0
    if (pass) { // 比最低值还小
      _lessThanMinIndexs.push(i)
    }
  })
  
  if (!_lessThanMinIndexs.length || array.length <= 1) {
    // 不需要做even操作
    // reset
    _evenHeightArr._count = 1
    return arr
  }
  
  if (arr.length && arr.every(v => `${v}` === '0')) {
    // 值都是0的数组
    const l = arr.length
    const one = Math.floor(100 / l)
    
    // reset
    _evenHeightArr._count = 1
    
    return arr.map((v, i) => {
      if (i >= (l - 1)) {
        // 最后一个
        return 100 - one * (l - 1)
      } else {
        return one
      }
    })
  }
  
  // even操作第一个小于_minGap的值
  // even操作第一个小于_minGap的值[step1], 先判断有几个大于_minGap的值
  const _largerThanMinIndexs = (arr.map((v, i) => {
    if (!_lessThanMinIndexs.includes(i)) {
      return i
    }
    return undefined
  })).filter(v => v !== undefined)
  
  const _largerThanMinCount = _largerThanMinIndexs.length
  const firstI = _lessThanMinIndexs[0]
  const firstV = arr[firstI]
  const gap = _minGap - firstV
  const one = gap / _largerThanMinCount
  
  // even操作第一个小于_minGap的值[step2], 把所有大于_minGap里头都减少one的数
  _largerThanMinIndexs.forEach(j => {
    arr[j] -= one
  })
  
  // 剩余比_minGap小的值组成一个新数组
  arr.splice(firstI, 1)
  const leftArr = arr
  const leftArrEvened = _evenHeightArr(leftArr)
  
  leftArrEvened.splice(firstI, 0, _minGap)
  const newArr = leftArrEvened
  log(`newArr: ${newArr}, firstI + 1: ${firstI + 1}`)
  
  // reset
  _evenHeightArr._count = 1
  return newArr.map(v => Math.round(v))
}

let _id = 1
export default {
  name: 'CChartBar',
  mixins: [reDrawTrigger],
  props: {
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    dontRatio: {
      type: [Number, Boolean, String],
      default: false
    },
    sizeRatio2: { // pump,七日图里头的
      type: [Number, Boolean, String],
      default: false
    },
    sizeRatio3: { // pump,daily graph里头
      type: [Number, Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    colors: {
      type: [Array],
      default: () => ['#A71111', '#F84C4C', '#3BD983', '#F4BC2A', '#ED873A'] // very low, low, target(normal), high, very high
    },
    rectNums: {
      type: [Array],
      default: () => [54, 70, 180, 250]
    },
    percentsWhat: {
      type: [Array],
      default: () => ['Very Low', 'Low', 'Target', 'High', 'Very High']
    },
    truePercents: {
      type: [Array],
      default: () => [0, 0, 0, 0, 0]
    },
    trueCounts: {
      type: [Array],
      default: () => []
    }
  },
  data() {
    _id++
    const id = `cbar_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    h() {
      const { w, sizeRatio2, sizeRatio3 } = this
      const plan1 = 221 / 455 * w // 宽一点，偏长方形
      const plan2 = 367 / 349 * w // 偏正方形
      const plan3 = 0.8 * w
      
      return (sizeRatio3 ? plan3 : (sizeRatio2 ? plan2 : plan1))
    },
    w() {
      const { sizeRatio2, sizeRatio3, ds, isLongLanguage } = this
      
      const r = 455 / 1754
      const plan1 = 455 / 1754 // 宽一点，偏长方形
      const plan2 = 349 / 1754 // 偏正方形
      // const plan3 = 280 / 1754
      let plan3 = 280 / 1754
      
      if (sizeRatio3 && isLongLanguage) {
        plan3 = 300 / 1754
      }

      const rst = (sizeRatio3 ? plan3 : (sizeRatio2 ? plan2 : plan1)) * ds
      if (sizeRatio3) {
        derror(`[bar]computed w rst: ${rst}, isLongLanguage: ${isLongLanguage}, sizeRatio3: ${sizeRatio3}`)
      }
      return rst
      // derror(`[bar]computed w: ${ds}, rst: ${r * ds}`)
    },
    style() {
      const { w, h, showMarginRight, zoomRatio, dontRatio } = this
      const rst = { zoom: dontRatio ? 1 : zoomRatio }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    }
  },
  mounted() {
    this.renderBars(false)
  },
  methods: {
    refreshTriggered() {
      // derror(`CharBar ${this.id}, this.refreshTriggered`)
      this.renderBars(true)
    },
    renderBars(isUpdate = false) {
      derror(`[${isUpdate ? 'update' : 'not update'}]renderBars`)
      const { id, w, h, lfs, stripeInnerBorderC, sizeRatio2, sizeRatio3, isLongLanguage } = this
      
      const { colors, rectNums, percentsWhat, truePercents, title } = this
      
      const ds = w
      const dimensions = {
        width: w, // 画布宽度
        height: h, // 画布高度
        margin: {
          top: 15,
          right: 15,
          bottom: 15,
          left: 20
        },
        text: {
          fontSize: lfs - 2,
          fontColor: '#000000',
          largerRatio: 1.4,
          height: 12,
          margin: 6
        }
      }

      // console.error(`chart bar sizeRatio3: ${sizeRatio3}, isLongLanguage: ${isLongLanguage}`)
      if (sizeRatio3) {
        const margin = dimensions.margin
        margin.left = 10
      }
      
      let _couldRenderBars = true
      /* eslint-disable */
      if (!(colors && colors.length >= 5)
          || !(rectNums && rectNums.length >= 4)
          || !(percentsWhat && percentsWhat.length >= 5)
          || !(truePercents && truePercents.length >= 5)) {
        /* eslint-enable */
        _couldRenderBars = false
      }
      
      const $barChart = d3.select(`#chartbar_${id}`)
      const svgId = `chartbar_svg_${id}`
      const svg = isUpdate ? $barChart.select(`#${svgId}`) : $barChart.append('svg')
      
      svg.attr('width', dimensions.width)
        .attr('height', dimensions.height)
        .attr('style', 'background-color:white')
        .attr('viewbox', `0 0 ${ds} ${ds}`)
        .attr('fill', dimensions.text.fontColor)
      
      if (!isUpdate) {
        svg.attr('id', svgId)
      }
      
      // 边框线
      const bId = `chartbar_svg_border_${id}`
      const borderG = isUpdate ? svg.select(`#${bId}`) : svg.append('g')
      if (!isUpdate) { // 第一次(init)
        borderG.attr('id', bId)
        // borderG.style('transform', `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)
      }
      // 画边框线的矩形
      borderG.selectAll('rect').data([
        {
          x: 0,
          y: 0,
          width: dimensions.width,
          height: dimensions.height
        }
      ])
        .join('rect')
        .attr('x', d => d.x)
        .attr('y', d => d.y)
        .attr('width', d => d.width)
        .attr('height', d => d.height)
        .attr('stroke', stripeInnerBorderC)
        .attr('stroke-width', 2)
        .attr('fill', 'white')
        .attr('rx', Math.floor(lfs))
      
      // 画title
      const tId = `chartbar_svg_title_${id}`
      const titleG = isUpdate ? svg.select(`#${tId}`) : svg.append('g')
      if (!isUpdate) { // 第一次(init)
        titleG.attr('id', tId)
        titleG.style('transform', `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)
      }
      
      // if (+truePercents[0] !== 0) {
      // }
      titleG.selectAll('text')
        .data([
          {
            x: 0,
            y: 10,
            height: lfs,
            fs: lfs,
            text: title,
            anchor: 'start'
          }
        ])
        .join('text')
        .text(d => d.text)
        .attr('font-size', d => `${d.fs ? d.fs : dimensions.text.fontSize}`)
        .attr('style', d => `font-weight: bold;text-anchor: ${d.anchor ? d.anchor : 'end'}`)
        .attr('x', d => d.x)
        .attr('y', d => d.y)
        .attr('fill', d => dimensions.text.fontColor)     
      
      if (!_couldRenderBars) {
        error(`${isUpdate ? 'update' : 'not update'}renderBars因为数据不足, 所以放一些假数据，至少把大体框架渲染出来`)
      }
      
      do {
        const { $t } = this
        const _truePercents = this.truePercents
        const _trueCounts = this.trueCounts
        let _targetCount = 0
        let _highCount = 0
        let _lowCount = 0 
        if (_trueCounts.length === 5) {
          _targetCount = _trueCounts[2]
          _highCount = _trueCounts[3] + _trueCounts[4]
          _lowCount = _trueCounts[0] + _trueCounts[1]
        }
        const _percentsWhat = this.percentsWhat
        const _colors = this.colors
        const truePercents = _couldRenderBars ? _truePercents : (_truePercents && _truePercents.length >= 5 ? _truePercents : [0, 0, 0, 0, 0])
        const percentsWhat = (_couldRenderBars ? _percentsWhat : (_percentsWhat && _percentsWhat.length >= 5 ? _percentsWhat : ['Very Low', 'Low', 'Target', 'High', 'Very High'].map(v => $t(v)))).map(v => this.$t(v))
        const colors = _couldRenderBars ? _colors : (_colors && _colors.length >= 5 ? _colors : ['#A71111', '#F84C4C', '#3BD983', '#F4BC2A', '#ED873A'])
        const percents = _evenHeightArr(truePercents) // 高度的percents,会给它们一个最小高度
        derror(`truePercents: `, truePercents)
        derror(`percents: `, percents)
        
        if (truePercents.length === 0) {
          error(`没有数据传入，无法渲染柱形图，直接return`)
          break
        }
        
        // if (+truePercents[0] === 0) {
        // }
        // 矩形图坐标
        const rects = {
          width: Math.round(42 * (w / 455)), // 矩形图宽度
          height: Math.round((h / 221) * (dimensions.height - 76)), // 矩形图高度(所有合起来)
          top: Math.round(36 * (h / 221)),
          left: Math.round(136 * (w / 455))
        }
        if (sizeRatio2) {
          rects.width = Math.round(42 * (w / 349))
          rects.height = Math.round((h / 367) * (dimensions.height - 102))
          rects.top = Math.round(56 * (h / 367))
          rects.left = Math.round(56 * (w / 349))
        }

        if (sizeRatio3) {
          rects.width = Math.round(42 * (w / 280))
          rects.height = Math.round((h / (280 * 0.8)) * (dimensions.height - 102))
          rects.top = Math.round(86 * (h / 367))
          rects.left = Math.round(30 * (w / 349))
        }
        
        Object.assign(rects, {
          bottom: rects.top + rects.height,
          right: rects.left + rects.width
        })
        
        // 根据percents计算出所有矩形的高度及x,y坐标
        const rectDrawParams = percents.map((v, i) => {
          let heightCurrentTotalPercents = 0
          for (let j = 0; j < i; j++) { // 不包含当前v
            heightCurrentTotalPercents += percents[j]
          }
          const heightBeforeCurrentTotal = Math.round(heightCurrentTotalPercents / 100 * rects.height)
          const h = Math.round(v / 100 * rects.height)
          return {
            x: rects.left,
            y: rects.bottom - heightBeforeCurrentTotal - h,
            height: h,
            width: rects.width,
            color: colors[i]
          }
        })
        
        const rectNumTextParams = (!(rectDrawParams && rectDrawParams.length >= 4)) ? [] : Array.from({ length: 4 }, (item, i) => {
          const height = dimensions.text.height
          const marginRight = dimensions.text.margin
          const rect = i < 2 ? rectDrawParams[i] : rectDrawParams[i + 1]
          
          const x = rect.x - marginRight
          const y = rect.y + height
          const rst = {
            x, y, height, text: rectNums[i]
          }
          
          // 微调
          /* eslint-disable indent */
          switch (i) {
          case 0: // 54
            if (truePercents[0] - _minGap < 0) { // 54
              // derror(`54`)
              rst.y -= 2
            }
            break
          case 1: // 70
            if (truePercents[1] - _minGap < 0) { // 70
              // derror(`70`)
              rst.y -= 4
            }
            break
          case 2: // 180
            rst.y = rect.y + rect.height
            if (truePercents[3] - _minGap < 0) { // 180
              // derror(`180`)
              rst.y += 3
            }
            break
          case 3: // 250
            rst.y = rect.y + rect.height
            if (truePercents[4] - _minGap < 0) { // 250
              // derror(`250`)
              rst.y -= 3
            }
            break
          }
          /* eslint-enable indent */
          
          return rst
        })
        // log(`rectNumTextParams, ${JSON.stringify(rectNumTextParams)}`)
        
        const rectPercentLabelParams = []
        const rectPercentLineParams = []
        const w1 = isLongLanguage ? 128 : 100 // line长度
        const w2 = 68 // 第二跟: 总结性百分比下面的那根线长度
        const w2Margin = 6 // 第二根线: 总结性百分比下面的那根线长度上面的文案的text-indent
        const w2MarginTop = 2 // 线和文字的空格
        const rectLineStartAndEndPoints = [] // 线的起始点(start&end pints)组成的数组
        
        rectDrawParams.forEach((rect, i) => { // 百分比label和线
          // const height = dimensions.text.height
          const marginLeft = dimensions.text.margin
          
          const what = percentsWhat[i]
          const whatValue = truePercents[i]
          
          const x = rect.x + marginLeft + rect.width
          let y = rect.y + Math.round(rect.height / 2)
          
          // 微调
          /* eslint-disable indent */
          switch (i) {
          case 0: // Very Low
            // derror(`rect: ${JSON.stringify(rect)}`)
            y = rect.y + +rect.height + dimensions.text.height
            break
          case 1: // Low
            break
          case 2: // Target
            break
          case 3: // High
            break
          case 4: // Very High
            y = rect.y - dimensions.text.height
            break
          }
          
          if (i === 1) {
            // Low
            if (truePercents[1] - _minGap <= 0) { // 优化: http://192.168.223.20/index.php?m=bug&f=view&bugID=3233
            // if (truePercents[2] - _minGap <= 0 && truePercents[1] - _minGap <= 0) {
              // Low 和 Target都是小于_minGap
              y += 3
            }
          }

          /* eslint-enable indent */
          
          for (let j = 0; j < 2; j++) {
            if (j === 0) {
              // what 的text 节点 
              const rst = {
                anchor: 'start', x, y, text: what
              }
              rectPercentLabelParams.push(rst)
              
              // 线
              const lineRst = {
                start: { x, y: y + w2MarginTop },
                end: { x: x + w1, y: y + w2MarginTop }
              }
              
              if (i === 2) {
                // Target
                lineRst.end.x += w2
              }
              rectLineStartAndEndPoints[i] = lineRst
              rectPercentLineParams.push(lineRst)
            } else {
              // value 的text节点
              const rst = {
                anchor: 'end', x: x + w1, y, text: `${whatValue.toFixed(0)}%`
              }
              if (i === 2) {
                // Target
                rst.x += (w2Margin)
                rst.anchor = 'start'
                rst.fs = dimensions.text.fontSize * dimensions.text.largerRatio
                
                // 总结性文案(n=1)
                const rst2 = Object.assign({}, rst)
                rst2.x += (lfs * 3)
                // rst2.text = '(n=1)' // Target BG                
                rst2.text = `(n=${_targetCount})`
                rst2.fs = dimensions.text.fontSize * 1.1
                rectPercentLabelParams.push(rst2)
              }
              rectPercentLabelParams.push(rst)
            }
          }
        })
        
        // 总结性的线和文案
        // 总结性的线和文案-step1.1: low的连接线
        const lineRstLowConnect = { // Connect的线
          start: {
            x: rectLineStartAndEndPoints[0].end.x,
            y: rectLineStartAndEndPoints[0].end.y
          },
          end: {
            x: rectLineStartAndEndPoints[1].end.x,
            y: rectLineStartAndEndPoints[1].end.y
          }
        }
        rectPercentLineParams.push(lineRstLowConnect)
        
        // 总结性的线和文案-step1.2: low的总结线和文案
        const lineRstLow = { // 总结线
          start: {
            x: rectLineStartAndEndPoints[0].end.x,
            y: Math.round((rectLineStartAndEndPoints[0].end.y + rectLineStartAndEndPoints[1].end.y) / 2)
          },
          end: {
            x: rectLineStartAndEndPoints[0].end.x + w2,
            y: Math.round((rectLineStartAndEndPoints[0].end.y + rectLineStartAndEndPoints[1].end.y) / 2)
          }
        }
        rectPercentLineParams.push(lineRstLow)
        // 总结文案
        const lineRstLowText = {
          anchor: 'start',
          x: rectLineStartAndEndPoints[0].end.x + w2Margin,
          y: Math.round((rectLineStartAndEndPoints[0].end.y + rectLineStartAndEndPoints[1].end.y) / 2) - w2MarginTop,
          fs: dimensions.text.fontSize * dimensions.text.largerRatio,
          text: `${(truePercents[0] + truePercents[1]).toFixed(0)}%`
        }
        // 总结文案后面的n=2
        const lineRstLowText2 = {
          anchor: 'start',
          x: rectLineStartAndEndPoints[0].end.x + w2Margin + lfs * 3,
          y: Math.round((rectLineStartAndEndPoints[0].end.y + rectLineStartAndEndPoints[1].end.y) / 2) - w2MarginTop,
          fs: dimensions.text.fontSize * 1.1,
          // text: ``
          text: `(n=${_lowCount})`
        }
        rectPercentLabelParams.push(lineRstLowText, lineRstLowText2)
        
        // 总结性的线和文案-step2.1: high的连接线
        const lineRstHighConnect = { // Connect的线
          start: {
            x: rectLineStartAndEndPoints[3].end.x,
            y: rectLineStartAndEndPoints[3].end.y
          },
          end: {
            x: rectLineStartAndEndPoints[4].end.x,
            y: rectLineStartAndEndPoints[4].end.y
          }
        }
        rectPercentLineParams.push(lineRstHighConnect)
        // 总结性的线和文案-step2.2: high的总结线和文案
        const lineRstHigh = { // 总结线
          start: {
            x: rectLineStartAndEndPoints[3].end.x,
            y: Math.round((rectLineStartAndEndPoints[3].end.y + rectLineStartAndEndPoints[4].end.y) / 2)
          },
          end: {
            x: rectLineStartAndEndPoints[3].end.x + w2,
            y: Math.round((rectLineStartAndEndPoints[3].end.y + rectLineStartAndEndPoints[4].end.y) / 2)
          }
        }
        rectPercentLineParams.push(lineRstHigh)
        
        // 总结文案22
        const lineRstHighText = {
          anchor: 'start',
          x: rectLineStartAndEndPoints[3].end.x + w2Margin,
          y: Math.round((rectLineStartAndEndPoints[3].end.y + rectLineStartAndEndPoints[4].end.y) / 2) - w2MarginTop,
          fs: dimensions.text.fontSize * dimensions.text.largerRatio,
          text: `${(truePercents[3] + truePercents[4]).toFixed(0)}%`
        }
        // 总结文案22后面的n=2
        const lineRstHighText2 = {
          anchor: 'start',
          x: rectLineStartAndEndPoints[3].end.x + w2Margin + lfs * 3,
          y: Math.round((rectLineStartAndEndPoints[3].end.y + rectLineStartAndEndPoints[4].end.y) / 2) - w2MarginTop,
          fs: dimensions.text.fontSize * 1.1,
          // text: `(n=2)`
          text: `(n=${_highCount})`
        }
        rectPercentLabelParams.push(lineRstHighText, lineRstHighText2)
        // 总结性的线和文案
        
        /* ++++++++++两根延伸线(共4笔画、4条线)++++++++++ */
        const extendHighStartPoint = {
          x: rectDrawParams[4].x + Math.round(rectDrawParams[4].width / 2),
          y: rectDrawParams[4].y - 4
        }
        const extendHighEndPoint = {
          x: rectLineStartAndEndPoints[4].start.x - 4,
          y: rectLineStartAndEndPoints[4].end.y - Math.round(dimensions.text.height / 2)
        }
        const extendHighTurnPoint = {
          x: rectDrawParams[4].x + Math.round(rectDrawParams[4].width / 2),
          y: rectLineStartAndEndPoints[4].end.y - Math.round(dimensions.text.height / 2)
        }
        
        rectPercentLineParams.push(...[{ start: extendHighStartPoint, end: extendHighTurnPoint }, { start: extendHighTurnPoint, end: extendHighEndPoint }])
        
        const extendLowStartPoint = {
          x: rectDrawParams[0].x + Math.round(rectDrawParams[4].width / 2),
          y: rectDrawParams[0].y + 4
        }
        const extendLowEndPoint = {
          x: rectLineStartAndEndPoints[0].start.x - 4,
          y: rectLineStartAndEndPoints[0].end.y - Math.round(dimensions.text.height / 2)
        }
        const extendLowTurnPoint = {
          x: rectDrawParams[0].x + Math.round(rectDrawParams[4].width / 2),
          y: rectLineStartAndEndPoints[0].end.y - Math.round(dimensions.text.height / 2)
        }
        
        rectPercentLineParams.push(...[{ start: extendLowStartPoint, end: extendLowTurnPoint }, { start: extendLowTurnPoint, end: extendLowEndPoint }])
        /* ++++++++++End of 两根延伸线++++++++++ */
        
        // 图表宽度
        dimensions.boundedWidth =
          dimensions.width - dimensions.margin.left - dimensions.margin.right
        // 图表高度
        dimensions.boundedHeight =
          dimensions.height - dimensions.margin.top - dimensions.margin.bottom
        
        // 画所有矩形图
        const gId = `chartbar_svg_g_${id}`
        const chartG = isUpdate ? svg.select(`#${gId}`) : svg.append('g')
        if (!isUpdate) { // 第一次(init)
          chartG.attr('id', gId)
          chartG.style('transform', `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)
        }
        
        chartG.selectAll('rect')
          .data(rectDrawParams)
          .join('rect')
          .attr('x', d => d.x)
          .attr('y', d => d.y)
          .attr('width', d => d.width)
          .attr('height', d => d.height)
          .attr('fill', d => d.color)
        
        // 矩形图边上标识数字&& 矩形图右边的百分比label
        chartG.selectAll('text')
          .data(rectNumTextParams.concat(rectPercentLabelParams))
          .join('text')
          .text(d => d.text)
          .attr('font-size', d => `${d.fs ? d.fs : dimensions.text.fontSize}`)
          .attr('style', d => `text-anchor: ${d.anchor ? d.anchor : 'end'}`)
          .attr('x', d => d.x)
          .attr('y', d => d.y)
          .attr('fill', d => dimensions.text.fontColor)
        
        // 矩形图右边的百分比的线
        // derror(`rectPercentLineParams.length: ${rectPercentLineParams.length}, ${JSON.stringify(rectPercentLineParams)}`)
        chartG.selectAll('line')
          .data(rectPercentLineParams)
          .join('line')
          .attr('x1', d => d.start.x)
          .attr('x2', d => d.end.x)
          .attr('y1', d => d.start.y)
          .attr('y2', d => d.end.y)
          .attr('stroke', stripeInnerBorderC)
          .attr('stroke-width', '0.5')
        /* eslint-disable-next-line */
      } while (false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
.bar-ctn {
    display: inline-block;
    @include bBox;
}
#barChart {
    overflow: hidden;
}
</style>
